class FAQ extends HTMLElement {
    constructor() {
        super();

        console.log(this.querySelector("[data-faq-container]"))

        this.querySelector("[data-faq-container]").querySelectorAll("[data-faq-category]").forEach(filterPanel => {
            filterPanel.addEventListener("click", () => {
                this.applyCategoryFilter(filterPanel.getAttribute("data-faq-category"));
                this.querySelector(".faq-new__tab-container__tab-active")?.classList.remove("faq-new__tab-container__tab-active");;  
                filterPanel.classList.add("faq-new__tab-container__tab-active");
            });
        });

        console.log(this.querySelector("input[data-faq-search]"))

        this.faqSearch = this.querySelector("input[data-faq-search]");

        this.faqSearch.addEventListener("keyup", () => {
            this.handleSearchQuery(this.faqSearch.value);
        });
    }

    enableDesktopSidebar(active) {
        this.querySelector(".faq-new__main-body__categories-container__categories").setAttribute("data-active", active);
    }

    handleSearchQuery(query) {
        if(!query || query === "") {
            this.enableDesktopSidebar(true)
            return;
        }

        this.querySelector(".faq-new__tab-container__tab-active")?.classList.remove("faq-new__tab-container__tab-active");;
        this.querySelector(".faq-new__tab-container__tab-active")
        this.enableDesktopSidebar(false);

        this.querySelectorAll(".faq-new__sub-category-container").forEach(subCategory => {
            const activeState = subCategory.innerHTML.includes(query);
            subCategory.setAttribute("data-active", activeState);
        });
    }

    applyCategoryFilter(filter) {
        console.log(filter)
        
        if(filter === "all") {
            this.querySelectorAll(".faq-new__sub-category-container[data-active='false']").forEach(subCategory => {
                subCategory.setAttribute("data-active", "true");
            });
            this.enableDesktopSidebar(true);
            return;
        }

        const appliedFilter = filter.split(",");
        
        this.querySelectorAll(".faq-new__sub-category-container").forEach(subCategory => {
            const activeState = appliedFilter.includes(subCategory.getAttribute("data-faq-category"));
            subCategory.setAttribute("data-active", activeState);
        });
        this.enableDesktopSidebar(false);


    }
}

customElements.define("custom-faq", FAQ);